<template>
  <div class="destination-filter">
    <label for="city">{{ $t('booking.filters.title.destination') }}</label>

    <city :ref="'city'"
          name="city"
          :options="options.city.options"
          @update="$emit('update', $event)"
    />

    <label for="hotel">{{ $t('booking.filters.title.hotel') }}</label>

    <hotel :ref="'hotel'"
           name="hotel"
           :options="options.hotel.options"
           @update="$emit('update', $event)"
    />
  </div>
</template>

<script>
import city from "./city";
import hotel from "./hotel";

export default {
  components: {
    city,
    hotel
  },

  props: {
    options: Object
  },

  methods: {
    reset () {
      for (let ref of Object.entries(this.$refs)) {
        ref[1].reset()
      }
    }
  }
}
</script>
